import { render, staticRenderFns } from "./infectiousReportCard.vue?vue&type=template&id=1b0b8de7"
import script from "./infectiousReportCard.vue?vue&type=script&lang=js"
export * from "./infectiousReportCard.vue?vue&type=script&lang=js"
import style0 from "./infectiousReportCard.vue?vue&type=style&index=0&id=1b0b8de7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports